import Nav from "../components/general/NavBar.jsx";
import Footer from "../components/general/footer.jsx";
import TypebotFrame from "../components/general/TypebotFrame.jsx";

const EvaluationFinaleRenforcementBureautique = () => {
  return (
    <section>
      <Nav />
      <div style={{ width: "100%", minHeight: "600px" }}>
        <TypebotFrame slug="valuation-finale-renforcement-bureautique-excel-power-point-word-c9if7yb"/>
      </div>
      <Footer border="contact" />
    </section>
  );
};

export default EvaluationFinaleRenforcementBureautique;